document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-notify-me]').forEach(function (notifyMe) {
    const openButton = notifyMe.querySelector('[data-notify-open]');
    const modal = notifyMe.querySelector('[data-notify-modal]');
    const closeButtons = notifyMe.querySelectorAll('[data-notify-close]');
    const form = notifyMe.querySelector('[data-notify-form]');

    const emailInput = notifyMe.querySelector('[data-notify-email]');
    const phoneInput = notifyMe.querySelector('[data-notify-phone]');
    const validationError = notifyMe.querySelector(
      '[data-notify-validation-error]'
    );

    const successMessage = notifyMe.querySelector('.notify-me__success');

    if (!openButton || !modal) return;

    function openModal() {
      modal.hidden = false;

      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });

      document.body.classList.add('notify-me-modal-open');

      setTimeout(function () {
        if (emailInput) {
          emailInput.focus();
        } else if (phoneInput) {
          phoneInput.focus();
        }
      }, 100);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('notify-me-modal-open');

      setTimeout(function () {
        modal.hidden = true;
      }, 200);
    }

    function hideValidationError() {
      if (validationError) {
        validationError.hidden = true;
      }
    }

    openButton.addEventListener('click', openModal);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    if (emailInput) {
      emailInput.addEventListener('input', hideValidationError);
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', hideValidationError);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        const email = emailInput ? emailInput.value.trim() : '';
        const phone = phoneInput ? phoneInput.value.trim() : '';

        /*
         * At least one contact method is required.
         */
        if (!email && !phone) {
          event.preventDefault();

          if (validationError) {
            validationError.hidden = false;
          }

          if (emailInput) {
            emailInput.focus();
          }

          return;
        }

        /*
         * If email was entered, let the browser
         * validate the email format normally.
         */
        if (email && emailInput && !emailInput.checkValidity()) {
          event.preventDefault();
          emailInput.reportValidity();
          return;
        }
      });
    }

    /*
     * Shopify reloads the page after a successful
     * contact form submission.
     */
    if (successMessage) {
      openModal();
    }
  });
});